/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactRoleWithRelations } from '../../models/contact-role-with-relations';

export interface GetContactRolesList$Params {
  orderType: string;
}

export function getContactRolesList(http: HttpClient, rootUrl: string, params: GetContactRolesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactRoleWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getContactRolesList.PATH, 'get');
  if (params) {
    rb.query('orderType', params.orderType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactRoleWithRelations>>;
    })
  );
}

getContactRolesList.PATH = '/editor/contact-roles';
